import styled from '@emotion/styled';

const DatePickerWrapper = styled('div')(({ theme }) => ({
  marginTop: 18,
  h3: {
    color: theme.palette.text.primary,
    fontSize: 'inherit',
    fontWeight: 500,
  },
}));

export default DatePickerWrapper;
